import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {getCurrentInstance, onMounted, ref} from 'vue';
import Events from "~/ts/library/Events";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import {isMobileWindowSize} from "~/core-ui/ts/CoreUiHelpersMixin";


const __default__ = {
    name: "StickyCard"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    height: {},
    bottom: { type: Boolean }
  },
  emits: ["update:height"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let headerStucks = ref(false);
let instance = getCurrentInstance().proxy;

let scrollListener = () => {
    let card = instance.$el as HTMLElement;

    if (card) {
        if (typeof props.height != "undefined") {
            let height = card.offsetHeight;
            if (props.height != height) {
                emits("update:height", height);
            }
        }
        if (props.bottom) {
            headerStucks.value = card.offsetTop < card.parentElement.offsetHeight;
        } else {
            headerStucks.value = card.offsetTop > 0;
        }
    }
};

addDisposableEvent(
    Events.addEventListener(
        "scroll",
        window,
        () => scrollListener(),
        {passive: true}
    )
);


onMounted(() => scrollListener());


return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, {
    ref: "card",
    class: _normalizeClass(_unref(isMobileWindowSize) ? null : ['card position-sticky', _unref(headerStucks) ? 'stucks' : '', _unref(props).bottom ? 'sticky-bottom' : 'sticky-top'])
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})